<template>

  <div class="alert alert-warning mb-0">
    <div class="d-flex">
      <div class="">
        <i class="far fa-calendar-alt" />
        Agendamento em <strong>{{ $d(new Date(next_event.start_at), 'long') }}</strong> - {{ next_event.duration }} min
      </div>
      <div
        v-if="next_event.meet_link"
        class="ml-auto">
        <span
          style="cursor: pointer"
          @click="expand = expand ? false : true"><i class="fas fa-chevron-down"></i></span>
      </div>
    </div>
    <div
      v-if="expand && next_event.meet_link"
      class="mt-3">
      <label><strong>URL da reunião</strong></label>
      <div class="input-group">
        <input
          type="text"
          class="form-control form-warning"
          :value="next_event.meet_link"
          ref="meet_link">
        <div
          class="input-group-append">
          <button
            type="button"
            class="btn btn-warning"
            @click="copy('meet_link')"><i class="fas fa-copy"></i></button>
          <a
            :href="next_event.meet_link"
            target="_blank"
            class="btn btn-warning"><i class="fas fa-external-link-alt"></i></a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'CandidateNextEvent',
  components: {
  },
  props: {
    next_event: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      expand: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    copy (ref) {
      const textBox = this.$refs[ref]
      textBox.select()
      document.execCommand('copy')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateNextEvent.vue